import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { translations } from '@/locale';
import Refresh from '@/components/Refresh';
import InviteVendorMemberModal from '@/components/Modal/InviteVendorMemberModal';
import { fetchUsers } from '@/services/api/users';
import { Input } from '@/components/ui/input';
import Typography from '@/components/Typography';
import { urls } from '@/constants';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogTrigger } from '@/components/ui/dialog';
import UserListTable from '@/components/UserListTable/UserListTable';

export interface Props {
  id: string;
}

const VendorMembersTab: React.FC<Props> = ({ id }) => {
  const [term, setTerm] = useState('');
  const [open, setOpen] = useState(false);

  return (
    <Refresh>
      {({ refresh, key }) => (
        <div className="space-y-4">
          <div className="flex space-x-4">
            <Input placeholder="Filter by name or email" onChange={(e) => setTerm(e.target.value)} />

            <Dialog open={open} onOpenChange={setOpen}>
              <DialogTrigger asChild>
                <Button variant="outline">Invite member</Button>
              </DialogTrigger>
              <DialogContent>
                <InviteVendorMemberModal
                  close={() => setOpen(false)}
                  vendorId={id}
                  onMemberInvited={() => {
                    refresh();
                    setOpen(false);
                  }}
                />
              </DialogContent>
            </Dialog>
          </div>

          <UserListTable
            key={JSON.stringify({ term, key })}
            source={(page, size) =>
              fetchUsers(page, size, {
                vendorId: id,
                organisationId: '',
                term: term,
                joinedAfter: new Date(0),
                joinedBefore: new Date()
              })
            }
          />
        </div>
      )}
    </Refresh>
  );
};

export default VendorMembersTab;
